import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiFileText, FiCalendar, FiMessageCircle, FiTrendingUp, FiBarChart3, FiSettings } = FiIcons;

const AdminPolicies = () => (
  <div className="px-4 sm:px-6 lg:px-8">
    <div className="mb-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Policy Management</h1>
      <p className="text-gray-600">Global policy management and oversight</p>
    </div>
    <div className="bg-white rounded-lg shadow p-6">
      <div className="text-center py-12">
        <SafeIcon icon={FiFileText} className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Policy Management</h3>
        <p className="text-gray-500">Global policy management features coming soon.</p>
      </div>
    </div>
  </div>
);

export default AdminPolicies;

// Create other admin pages in a single file to save space
export const AdminCoaching = () => (
  <div className="px-4 sm:px-6 lg:px-8">
    <div className="mb-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Coaching Oversight</h1>
      <p className="text-gray-600">Monitor coaching activities system-wide</p>
    </div>
    <div className="bg-white rounded-lg shadow p-6">
      <div className="text-center py-12">
        <SafeIcon icon={FiMessageCircle} className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Coaching Oversight</h3>
        <p className="text-gray-500">Coaching oversight features coming soon.</p>
      </div>
    </div>
  </div>
);

export const AdminReports = () => (
  <div className="px-4 sm:px-6 lg:px-8">
    <div className="mb-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Reports & Analytics</h1>
      <p className="text-gray-600">Generate system reports and analytics</p>
    </div>
    <div className="bg-white rounded-lg shadow p-6">
      <div className="text-center py-12">
        <SafeIcon icon={FiBarChart3} className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Reports & Analytics</h3>
        <p className="text-gray-500">Reporting features coming soon.</p>
      </div>
    </div>
  </div>
);

export const AdminSettings = () => (
  <div className="px-4 sm:px-6 lg:px-8">
    <div className="mb-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">System Settings</h1>
      <p className="text-gray-600">Configure system settings and preferences</p>
    </div>
    <div className="bg-white rounded-lg shadow p-6">
      <div className="text-center py-12">
        <SafeIcon icon={FiSettings} className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">System Settings</h3>
        <p className="text-gray-500">System configuration features coming soon.</p>
      </div>
    </div>
  </div>
);
